<template>
    <div class="main-wrap">
        <Title :title="title" />
        <Classify v-model:active="classifyActive" :data="classify" :label-key="labelKey" @change="changeClassify" />
        <Notice ref="notice" :project-type="projectType" v-model:bizId="bizId" />
        <el-button class="link" type="primary" link @click="goInformation">更多＞</el-button>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick } from 'vue'
import { Clock } from '@element-plus/icons-vue'
import { pageJump } from '@/global/location-transfer'
import Card from '@/views/scientific-research/components/card.vue'
import Title from '@/views/scientific-research/components/title.vue'
import Notice from '@/views/scientific-research/components/notice.vue'
import Classify from '@/views/scientific-research/components/classify.vue'
import ColumnList from '@/views/shenzhen/components/column-list.vue'
import NoData from '@/components/no-data.vue'
import dayjs from 'dayjs'

const props = defineProps({
    title: {
        type: [String, Number],
        default: '',
    },
})

onMounted(init)

// 初始化
const loaded = ref(true)
async function init() {
    loaded.value = true
    await Promise.allSettled([getClassify()])
    await changeClassify()
    loaded.value = false
}

// 获取分类
const labelKey = 'name'
const classify = ref([])
async function getClassify() {
    try {
        const res = await G_transmit('escHomeGetProjectType', {})
        classify.value = [{ [labelKey]: '全部' }].concat(res?.data || [])
    } catch (error) {
        classify.value = []
    }
}

// 分类选择
const classifyActive = ref()
const classifyValues = computed(() => classify.value?.[classifyActive.value])
async function changeClassify(index) {
    classifyActive.value = index || 0
    await getDataList()
}

// 字段参数
const projectType = computed(() => classifyValues.value?.code)

// 获取数据列表
const notice = ref()
async function getDataList() {
    await nextTick()
    notice.value?.init?.()
}

// 新闻资讯
const bizId = ref('')
function goInformation() {
    const query = { catId2: bizId.value }
    pageJump({ name: 'information', query }, true)
}
</script>

<style lang="scss" scoped>
.main-wrap {
    gap: 24px;
    display: flex;
    flex-flow: column;
    position: relative;
    .title {
        align-self: center;
    }
    .notice {
        justify-content: center;
    }
    .link {
        position: absolute;
        top: 68px;
        right: 0;
    }
}
</style>
